export default "__VITE_ASSET__6fee0c57__"